<div class="lead-broker-start-container">
  <div class="header">
    <div>{{ title }}</div>
    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      (click)="closeDialog()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>

  <div class="main-container">
    <div class="main-container-inner">
      @if (targets.length) {
        <div class="max-partners">
          <fi-input
            type="NUMBER"
            labelKey="ACTION_LEAD_BROKER_START_OVERLAY_MAX_PARTNERS"
            [selectedOptionsOrValues]="maxAcceptedPartners"
            [hasError]="maxAcceptedPartnersInvalid"
            errorKey="ACTION_LEAD_BROKER_START_OVERLAY_MAX_PARTNERS_ERROR_TEXT"
            [errorParams]="{ BrokeringTargetsMaxPartners: maxAllowedPartners }"
            (onChange)="onMaxAcceptedPartnersChange($event)"
          ></fi-input>
        </div>
      }

      @if (loading) {
        <div class="state-container">
          <mat-spinner diameter="32"></mat-spinner>
        </div>
      }

      @if (!loading && (hasLoadError || !targets.length)) {
        <div class="empty-state">
          <img src="assets/icons/new/map_marker.svg" alt=""/>
          <div class="empty-title" fiTranslation="ACTION_LEAD_BROKER_START_OVERLAY_EMPTY_HEADLINE"></div>
          <div class="empty-text">
            <span fiTranslation="ACTION_LEAD_BROKER_START_OVERLAY_EMPTY_TEXT_1"></span>
            <br/><br/>
            <span fiTranslation="ACTION_LEAD_BROKER_START_OVERLAY_EMPTY_TEXT_2"></span>
          </div>
        </div>
      }

      @if (!loading && !hasLoadError && targets.length) {
        @if (firstWaveTargets.length) {
          <div class="wave-section first-wave">
            <div class="target-layout">
              @for (target of firstWaveTargets; track target) {
                <ng-container *ngTemplateOutlet="targetCard; context: { $implicit: target }"></ng-container>
              }
            </div>
          </div>
        }
        @if (secondWaveTargets.length) {
          <div class="wave-section" [class.second-wave]="firstWaveTargets.length">
            @if (firstWaveTargets.length) {
              <div class="wave-note"
              fiTranslation="ACTION_LEAD_BROKER_START_OVERLAY_INFO_SECOND_WAVE"></div>
            }
            <div class="target-layout">
              @for (target of secondWaveTargets; track target) {
                <ng-container *ngTemplateOutlet="targetCard; context: { $implicit: target }"></ng-container>
              }
            </div>
          </div>
        }
      }
    </div>
  </div>

  <div class="footer">
    <button type="button" (click)="submit()" [disabled]="!formIsValid">
      <img [src]="iconUrl" alt="Action icon">
      <span>{{ title }}</span>
    </button>
  </div>
</div>

<ng-template #targetCard let-target>
  <div class="target-card">
    <div class="card-info" [class.has-logo]="target.LogoUrl">
      <div class="info-box">
        <div class="info-box-inner">
          <div class="kkz">{{ target.KKZ }}</div>
          <div class="company">{{ target.Name }}</div>

          <div class="address">
            @if (target.Address?.Address) {
              <span>{{ target.Address.Address }}</span>
            }
            @if (target.Address?.AddressExt) {
              <span>{{ target.Address.AddressExt }}</span>
            }
            @if (target.Address?.ZipCode || target.Address?.City || target.Address?.ProvinceText) {
              <span>
                {{ target.Address?.ZipCode }} {{ target.Address?.City }} {{ target.Address?.ProvinceText ? '(' + target.Address.ProvinceText + ')' : '' }}
              </span>
            }
            @if (target.Address?.CountryText) {
              <span>{{ target.Address.CountryText }}</span>
            }
          </div>
        </div>

        <div class="extra-info">
          <div class="extra-info-item distance">
            <img src="assets/icons/new/location.svg" alt="" #distanceIcon
              fiTranslation="ACTION_LEAD_BROKER_START_OVERLAY_DISTANCE_TOOLTIP" [isTitle]="true"
              matTooltip="{{ distanceIcon.dataset.matTooltip }}" matTooltipPosition="below"
              matTooltipClass='tooltip-style'/>
            <span>{{ target.Distance | toDistance }}</span>
          </div>
          @if (target.IsNewCustomer) {
            <div class="extra-info-item is-new-partner">
              <img src="assets/icons/new/new-partner.svg" alt="" #newPartner
                fiTranslation="ACTION_LEAD_BROKER_START_OVERLAY_NEW_PARTNER_TOOLTIP" [isTitle]="true"
                matTooltip="{{ newPartner.dataset.matTooltip }}" matTooltipPosition="below"
                matTooltipClass='tooltip-style'/>
              <span fiTranslation="ACTION_LEAD_BROKER_START_OVERLAY_NEW_PARTNER"></span>
            </div>
          }
        </div>
      </div>


      @if (target.ContactManager?.FirstName || target.ContactManager?.LastName || target.ContactManager?.Organisation) {
        <div class="manager"
          >
          @if (target.ContactManager?.FirstName || target.ContactManager?.LastName) {
            <span>
              {{ target.ContactManager?.FirstName }} {{ target.ContactManager?.LastName }}
            </span>
          }
          @if ((target.ContactManager?.FirstName || target.ContactManager?.LastName) && target.ContactManager?.Organisation) {
            <span
            > - </span>
          }
          @if (target.ContactManager?.Organisation) {
            <span>{{ target.ContactManager.Organisation }}</span>
          }
        </div>
      }
    </div>

    @if (target.LogoUrl) {
      <div class="logo-box">
        <img [src]="target.LogoUrl" alt="Logo">
      </div>
    }
  </div>
</ng-template>
